
let Constants = {
    PAYMENT_LINK : {
        NEW : "/paymentLink",
        VERIFY : (paymentLinkId) => `/paymentLink/verify/${paymentLinkId}`,
        GET : (paymentLinkId) => `/paymentLink/${paymentLinkId}`,
        GETALL : () => `/admin/paymentLinks`,
        VERIFY_PAYMENT : (paymentLinkId, reference) => `/paymentLink/${paymentLinkId}/${reference}/status`,
        INITIATE_PAYMENT : `/payment/initiate`,
        RESOLVE_EMAIL_ADDRESS : (emailAddress, paymentLinkId) => `/misc/resolveEmail/${emailAddress}/${paymentLinkId}`,
        RESOLVE_DISCOUNT_CODE : (paymentLinkId,discountCode) => `/discount/code/${paymentLinkId}/${discountCode}`
    },
    DISCOUNT_CODES : {
        NEW : "/discount/code/generate",
        FETCH_ONE : (discountId) => `/discount/code/${discountId}`,
        FETCH_ALL : `/discount/codes`
    },
    ADMIN : {
        FETCH_TRANSACTIONS : "/admin/transactions",
        FETCH_USERS : "/admin/users",
        FETCH_PAYMENT_LINKS: "/admin/paymentLinks",
        FETCH_WITHDRAWALS : "/admin/withdrawals",
        FETCH_CUSTOMERS : "/admin/customers",
        FETCH_WALLETS : "/admin/wallets",
        FETCH_DISCOUNT : "/admin/discountcodes",
        FETCH_PLATFORM_SUMMARY : "/admin/platform-summary",
        FETCH_ : "/admin/wallets",
        WITHDRAWALS : {
            FETCH_ONE : (withdrawalId) => ``,
            APPROVE_ONE : (withdrawalId) => ``,
            REJECT_ONE : (withdrawalId) => ``,
        }
    },
    ONBOARD: {
        INITIATE: "/v1/onboard",
        CONFIRM_OTP: {
            EMAIL_ADDRESS: "/v1/auth/onboard/confirmOtp/email",
            MOBILE_NUMBER: "/v1/auth/onboard/confirmOtp/mobileNumber"
        },
        RESEND_CODE : "/auth/code/send"
    },
    MONO_KEY : "live_pk_z1h059s0lwp9zsj623na",//"test_pk_de183yil1g6bzgnm4nzn",
    LOGIN: {
        INITIATE: "/auth/login",
        CONFIRM_OTP: {
            EMAIL_ADDRESS: "/v1/auth/login/confirmOtp/email",
            MOBILE_NUMBER: "/v1/auth/login/confirmOtp/mobileNumber"
        }
    },
    
    PASSWORD_RESET : {
        GENERATE : "/auth/password/reset/initiate",
        VERIFY : (code) =>  `/auth/password/reset/verify/${code}`,
        RESET : "/auth/password/reset"
    },     
    SIGNUP : "/auth/signup",
    VERIFY_EMAILADDRESS : (emailAddress,verificationAuthCode) => `/auth/code/verify/email/${emailAddress}/authCode/${verificationAuthCode}`,
    USER: {
        PROFILE: "/user/profile",
        BANKS : "/withdrawal/bank-details",
        ADD_BANKS : "",
        REFERRALS : "/user/referrals",
        REFERRAL_EARNINGS : "/user/referral/earnings",
        FETCH_CUSTOMERS : "/customers",
        TRANSACTIONS : "/transactions",
        WITHDRAW : "/withdrawal/auto",
        WITHDRAWALS : "/withdrawals",
        ADD_CUSTOMER : "/customers/add"
    },
    SETTINGS : {
        NEW : "/settings",
        FETCH : "/settings",
        SAVE : "/settings"
    },
    PAY : {
        INITIATE : "/payment/initialize",
        VERIFY : (reference) => `/payment/verify/${reference}`,
        INITIATE_COLLECTION : (pageSlugId) => {
            if(!pageSlugId) throw "Page Slug Id not used";
            return `/payment/initialize/collection/${pageSlugId}`
        }
    },
    PAGE : {
        CREATE : "/collection-payment-page",
        ONE : (pageId) => `/collection-payment-page/${pageId}`,
        ALL : `/collection-payment-pages`,
        UPDATE : (pageId) => `/collection-payment-page/${pageId}`,
        DELETE : (pageId) => `/collection-payment-page/${pageId}`,
        TRANSACTIONS : {
            ALL : (pageSlugId) => `/transactions/${pageSlugId}`,
            ONE : (pageSlugId, transactionId) => `/transaction/${transactionId}`
        }
    },
    TRANSACTIONS: {
        FUND: "/stash/topup/initiate",
        WITHDRAW: "/withdrawal/auto",
        FETCH : "/user/transactions"
    },
    INVESTOR_TYPES: [
        {
            id: "1",
            name: "Beginner",
            icon: 1,
        },
        {
            id: "2",
            name: "Intermediate",
            icon: 2
        },
        {
            id: "3",
            name: "Experienced",
            icon: 3
        }
    ],
    nairaString: "₦",
    LANDING_PAGE: [
        {
            heroText: "Small steps, Big change.",
            subText: `So much of our impact on the Earth is determined by how we spend and make our money. For example, when we purchase a generator set from an electronic retail brand, our money supports the manufacturing of plastic-based metals, the use of fossil fuel energy, excess air waste, and in most cases, unfair labor practices.
            You can reverse this when you put your money into sustainable practices that supports organic food production, renewable energy, zero-plastic manufacturing, and fair labor practices. These are business practices that leave the Earth better than we found it.`,
        },
        {
            heroText: "Contribute",
            subText: `Put your money where your values are. Make a personal impact on the planet by
            saving into green portfolios for competitive returns and sustainable wealth creation.`
        },

        {
            heroText: "Split",
            subText: `Break payments into smaller bits at lower rates when you purchase
            Solar energy assets or energy saving appliances from our partners.`
        },

        {
            heroText: "Rewards",
            subText: `Earn green points when you invite your network, friends and family
            to save on Rouzo and join the efforts of building a greener planet.`
        },

        {
            heroText: "",
            subText: ""
        }
    ]

}

export default Constants;